import { Address } from './address'
import { CreditApplicationStatus } from './cash'
import { Entitlement, ProductSubscription } from './productSubscription'

export interface SlimTeamCarrier {
  name: string
  mcNumber: string
}

// TODO: @console-side-drawer
export type TeamMember = any

export interface SlimTeam {
  id?: string
  name?: string
  isApproved?: boolean
  entitlements?: Entitlement[]
  carrier?: SlimTeamCarrier
}

export interface Team extends SlimTeam {
  numPowerUnits?: number
  numTrailers?: number
  composition?: string
  dotNumber?: string
  mcNumber?: string
  locationCity?: string
  locationState?: string
  referralSource?: string
  dateCreated?: string
  dateUpdated?: string
  dateEsignActConsent?: string
  numTrailersDryVan?: string
  numTrailersFlatbed?: string
  numTrailersReefer?: string
  stripeAccountCreated?: boolean
  numActiveDrivers: number
  billingAddress: Address
  ratesVisibleToNonAdmins?: boolean
  productSubscription: ProductSubscription
  ctMcNumber: string
  plaidAssetsEligible?: boolean
  creditStatus?: CreditApplicationStatus
  businessType?: BusinessType
  businessDocumentation?: string
  legalNameBusiness?: string
  legalFormationState?: string
  legalBusinessOwner?: string
  isCreditStatusOpenToUser?: boolean
  hasTaxId?: boolean
  isTaxInfoComplete?: boolean
  formattedSubscriptionName?: boolean
}

export enum BusinessType {
  LLC = 'LLC',
  CORP = 'CORP',
  SOLE_PROPRIETORSHIP = 'SP',
}
